import React, { useEffect, useRef, useState } from 'react';
import { playConfirm } from '../../../utils/sounds';
import './resume.css';

import civilResume from '../../../assets/civil.pdf';
import techResume from '../../../assets/tech.pdf';

export const Resume = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  const openPdf = (type) => {
    playConfirm();
    window.open(type === 'civil' ? civilResume : techResume, '_blank');
  };

  return (
    <section
      id="Resume"
      className={`resume-section ${visible ? 'visible' : ''}`}
      ref={ref}
      aria-label="Resume Downloads"
    >
      <div className="container">
        <div className="section-header">
          <h2>RESUME</h2>
        </div>

        <div className="resume-grid">
          {/* Civil Resume */}
          <div className="terminal-window resume-card">
            <div className="terminal-header">
              <div className="dots">
                <span className="dot active"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
              <span>civil_resume.pdf</span>
            </div>
            <div className="terminal-body resume-body">
              <div className="resume-icon">{'\u25A3'}</div>
              <h3 className="resume-label">CIVIL ENGINEERING</h3>
              <p className="resume-desc">
                Land development, grading, servicing, stormwater management, and construction documentation.
              </p>
              <button className="crt-button" onClick={() => openPdf('civil')}>
                {'\u25B6'} VIEW RESUME
              </button>
            </div>
          </div>

          {/* Tech Resume */}
          <div className="terminal-window resume-card">
            <div className="terminal-header">
              <div className="dots">
                <span className="dot active"></span>
                <span className="dot"></span>
                <span className="dot"></span>
              </div>
              <span>tech_resume.pdf</span>
            </div>
            <div className="terminal-body resume-body">
              <div className="resume-icon">{'\u27E8/\u27E9'}</div>
              <h3 className="resume-label">TECHNOLOGY</h3>
              <p className="resume-desc">
                Python, JavaScript, AutoLISP, design automation, AI/ML projects, and web development.
              </p>
              <button className="crt-button amber" onClick={() => openPdf('tech')}>
                {'\u25B6'} VIEW RESUME
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
